window.isSafari =  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);;

/**
 * Custom scrollBy that handles Safari's issues with scrollBy and scroll snapping
 * @param {ScrollToOptions} options - The scroll options (left, top, behavior)
 */
HTMLElement.prototype._scrollBy = function(options) {
  if (!window.isSafari) {
    this.scrollBy(options);
    return;
  }

  // Safari has issues with scrollBy and scroll snapping
  // Use scrollTo with calculated position instead
  this.scrollTo({
    left: this.scrollLeft + (options.left || 0),
    top: this.scrollTop + (options.top || 0),
    behavior: options.behavior || 'smooth',
  });
};